var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['group-151', _vm.className]},_vm._l((_vm.count),function(i){return _c('div',{key:i,staticClass:"seg",class:{ active: _vm.active === i - 1 },on:{"click":function($event){return _vm.select(i - 1)}}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }